(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('VCUserDeleteController',VCUserDeleteController);

    VCUserDeleteController.$inject = ['$uibModalInstance', 'entity', 'VCUser'];

    function VCUserDeleteController($uibModalInstance, entity, VCUser) {
        var vm = this;

        vm.vCUser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VCUser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
